'use client';

import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { AttentionIcon } from '@depop/web-ui-kit/Icons/AttentionIcon';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';

import styles from '../styles.module.css';

import { useProductsSearchWithFallback } from '@/modules/search/useProductsSearchWithFallback';

export function NoResultsFallbackBanner() {
  const params = useSearchParams();
  const { data, isFallbackResponse } = useProductsSearchWithFallback(
    params.get('q') || ''
  );
  const t = useTranslations('search');

  if (
    data?.pages[0]?.data.products &&
    data.pages[0].data.products.length > 0 &&
    isFallbackResponse
  ) {
    return (
      <div className={styles.noResultsFallbackContainer}>
        <AttentionIcon size={24} />
        <div className={styles.noResultsFallbackTextContainer}>
          <Body variant="sm-regular" className={styles.noResultsFallbackTitle}>
            {t('NoResultsFallbackHeader')}
          </Body>
          <Body variant="sm-regular">
            {t('NoResultsFallbackMessage', { country: 'US' })}
          </Body>
        </div>
      </div>
    );
  }

  return;
}
